import { NgModule } from '@angular/core';
import { PermissionsHub } from './permissions.hub';

@NgModule({
    providers: [PermissionsHub]
})
export class SignalRModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/signalr/signalr.module.ts